export var ECOMMERCE_ACTIONS = {
    VIEW_DETAIL: 'detail',
    ADD_TO_CART: 'add',
    REMOVE_FROM_CART: 'remove',
    CLICK: 'click',
    CHECKOUT: 'checkout',
    CHECKOUT_OPTION: 'checkout_option',
    PURCHASE: 'purchase'
};



//////////////////
// WEBPACK FOOTER
// ./src/common/analytic-events/ecommerceActions.ts
// module id = HpAA
// module chunks = 18